module.exports = __webpack_public_path__ + "img/logo.047ac501.jpg";